module.exports = __webpack_public_path__ + "static/media/wedding.4907e943.jpg";